import axios from 'axios';
import ZoomType from 'utils/constants/zoomType';

export default async (type: ZoomType = 2) => {
  const { data: hearingPhone } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/hearingNumber/${
      type === ZoomType.Pro
    }`
  );
  return hearingPhone.phoneNumber;
};
